webpackJsonp([40708631970666],{

/***/ 1020:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0019_harvest_reaper.jpg","type":"Unit","subtype":"Contraption","cost":5,"ATK":6,"HP":5,"rules_text_1":"Overpower (Excess combat damage this would deal to a patroller hits something else this could attack.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Harvest Reaper","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"It reaps the fields. It reaps you.","color":"Neutral","spec":"Bashing","bottom":"Tech II","rulings":[],"keywords":["Overpower"],"slug":"harvest_reaper"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"harvest_reaper","keywords":["Overpower"],"imageRegex":"/harvest_reaper.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-harvest-reaper-bce67f870042e8bace2d.js